import { faRefresh, faExclamation, faCheck, faClose, faPen, faBan, faBoxArchive, faClipboardCheck, faCheckDouble, faCheckCircle } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import "./style.css"

const StatusSolCompartilhamento = ({ value }) => {
    switch (value) {
        case 0:
            return (
                <Tooltip title="Em digitação" placement="right">
                    <div className="status_digitacao">
                        <FontAwesomeIcon icon={faPen} />
                    </div>
                </Tooltip>
            )
        case 1:
            return (
                <Tooltip title="Pendente de homologação" placement="right">
                    <div className="status_pendente">
                        <FontAwesomeIcon icon={faRefresh} />
                    </div>
                </Tooltip>
            );
        case 2:
            return (
                <Tooltip title="Revisão" placement="right">
                    <div className="status_revisao">
                        <FontAwesomeIcon icon={faExclamation} />
                    </div>
                </Tooltip>
            );
        case 4:
            return (
                <Tooltip title="Atualização MIG pendente" placement="right">
                    <div className="status_aprovado">
                        <FontAwesomeIcon icon={faCheckCircle} />
                    </div>
                </Tooltip>
            );
        case 5:
            return (
                <Tooltip title="Em fiscalização" placement="right">
                    <div className="status_vistoria">
                        <FontAwesomeIcon icon={faClipboardCheck} />
                    </div>
                </Tooltip>
            );
        case 6:
            return (
                <Tooltip title="Cancelado" placement="right">
                    <div className="status_cancelado">
                        <FontAwesomeIcon icon={faBan} />
                    </div>
                </Tooltip>
            );
        case 7:
            return (
                <Tooltip title="Arquivado" placement="right">
                    <div className="status_arquivada">
                        <FontAwesomeIcon icon={faBoxArchive} />
                    </div>
                </Tooltip>
            );
        case 8:
            return (
                <Tooltip title="Concluído" placement="right">
                    <div className="status_concluido">
                        <FontAwesomeIcon icon={faCheckDouble} />
                    </div>
                </Tooltip>
            );
    }
}

export { StatusSolCompartilhamento };